<template>
  <div class="sm-img-loader">
    <img
      v-show="status == 'loaded'"
      class="sm-img-loader__image"
      :src="src"
      @load="onLoad"
      @error="onError"
    >
    <div
      v-if="status == 'loading'"
      class="sm-img-loader__spinner"
    >
      <lottie
        :options="options"
        :height="36"
        :width="36"
      />
      <!-- <span></span>
      <span></span>
      <span></span> -->
    </div>
    <div
      v-if="status == 'error'"
      class="sm-img-loader__error"
    >
      <include-svg
        v-if="errorIcon"
        :name="errorIcon"
      />
    </div>
  </div>
</template>

<script>
import Lottie from 'vue-lottie';
import AnimationData from '@/assets/json/spinner.json';

export default {
  name: 'img-loader',
  components: {
    'lottie': Lottie
  },
  props: {
    src: {
      type: String,
      default: null
    },
    errorIcon: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      status: 'loading',
      options: {
        animationData: AnimationData
      }
    };
  },
  methods: {
    onLoad() {
      this.status = 'loaded';
    },
    onError() {
      this.status = 'error';
    }
  },
  watch: {
    src(val) {
      this.status = 'loading';
    }
  }
}
</script>
